import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable, auditTime, startWith, takeUntil } from 'rxjs';
import { getChildObjects, getFormRoot } from './form-data.utility';
import { FormlyHookFn } from './formly-hook-fn.type';

export const setBgeCompletenessRecommendation = (
  destroyed$: Observable<unknown>
): FormlyHookFn => (field) => {
  const root = getFormRoot(field);

  root.formControl.valueChanges.pipe(
    startWith(null),
    takeUntil(destroyed$)
  ).subscribe(() => {
    const checks = getChildObjects(root.fieldGroup, 'intActionField') as FormlyFieldConfig[];
    const traditional = root.model.overall_result;
    const failedChecks = checks.filter(check =>
      check.props?.notLoaded === false && check.props?.valuesMatch === false
    );
    const intelligentActionsPassed = checks.every(check =>
      check.props?.notLoaded === true ||
      (check.props?.notLoaded === false && check.props?.valuesMatch === true)
    );
    const succeeded = traditional?.succeeded === true && intelligentActionsPassed;

    root.model.combined_overall_result = {
      succeeded,
      recommendation: succeeded ? 'Pass' : 'Fail',
      detail: [
        traditional?.detail,
        ...failedChecks.map(check =>
          `${check.props.intelligentActionName || check.props.ruleName || check.key}: extracted and form values do not match.`
        ),
      ].filter(Boolean).join('\n'),
    };
    field.options?.detectChanges?.(field);
  });
};
